// ==========================================================================
// CACTUS KNIGHT — Produktsuche (Slide-in-Panel von links)
// Eigene clientseitige Fuzzy-Suche statt Shopifys strikter Predictive-Search.
// Lädt den Produktkatalog einmalig (Titel, Tags, Typ, Vendor) und matched
// per Teilstring + Tippfehler-Toleranz (Levenshtein), damit z.B. "parralletts"
// trotzdem "Parallettes" im Tag findet. Zeigt ALLE Treffer als Liste an.
// Bei Enter: genau 1 Treffer -> direkt zum Produkt. 0 oder mehrere Treffer ->
// weiter zur eigenen (gestylten) Ergebnisseite /search.
// ==========================================================================

document.addEventListener("DOMContentLoaded", () => {
  const overlay = document.getElementById("search-drawer-overlay");
  const drawer = document.getElementById("search-drawer");
  const openBtns = document.querySelectorAll("[data-search-open]");
  const closeBtn = document.getElementById("search-close");
  const input = document.getElementById("search-input");
  const resultsEl = document.getElementById("search-results");
  const form = document.getElementById("search-form");
  const searchUrl = (form && form.getAttribute("data-search-url")) || "/search";

  if (!overlay || !drawer || !input || !resultsEl) return;

  let debounceTimer = null;
  let catalogPromise = null;

  function openSearch() {
    overlay.removeAttribute("hidden");
    drawer.removeAttribute("hidden");
    drawer.setAttribute("aria-hidden", "false");
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        overlay.classList.add("is-visible");
        drawer.classList.add("is-open");
      });
    });
    document.body.style.overflow = "hidden";
    setTimeout(() => input.focus(), 300);
    resultsEl.innerHTML = "";
    loadCatalog();
  }

  function closeSearch() {
    overlay.classList.remove("is-visible");
    drawer.classList.remove("is-open");
    drawer.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
    setTimeout(() => {
      overlay.setAttribute("hidden", "");
      drawer.setAttribute("hidden", "");
      input.value = "";
      resultsEl.innerHTML = "";
    }, 600);
  }

  function escapeHtml(str) {
    const div = document.createElement("div");
    div.textContent = str;
    return div.innerHTML;
  }

  function normalize(str) {
    return (str || "")
      .toString()
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "");
  }

  function levenshtein(a, b) {
    if (a === b) return 0;
    const al = a.length, bl = b.length;
    if (al === 0) return bl;
    if (bl === 0) return al;
    let prev = new Array(bl + 1);
    for (let j = 0; j <= bl; j++) prev[j] = j;
    for (let i = 1; i <= al; i++) {
      const curr = [i];
      for (let j = 1; j <= bl; j++) {
        const cost = a[i - 1] === b[j - 1] ? 0 : 1;
        curr[j] = Math.min(curr[j - 1] + 1, prev[j] + 1, prev[j - 1] + cost);
      }
      prev = curr;
    }
    return prev[bl];
  }

  function fuzzyWordScore(needle, haystackWords) {
    let best = 0;
    for (const w of haystackWords) {
      if (!w) continue;
      if (w === needle) {
        best = Math.max(best, 100);
      } else if (w.includes(needle) || needle.includes(w)) {
        const ratio = Math.min(needle.length, w.length) / Math.max(needle.length, w.length);
        best = Math.max(best, 70 * ratio);
      } else {
        const threshold = needle.length <= 4 ? 1 : needle.length <= 7 ? 2 : 3;
        const dist = levenshtein(needle, w);
        if (dist <= threshold) {
          best = Math.max(best, 50 - dist * 10);
        }
      }
    }
    return best;
  }

  async function loadCatalog() {
    if (catalogPromise) return catalogPromise;
    catalogPromise = fetch(`/products.json?limit=250`)
      .then((res) => res.json())
      .then((data) => {
        const products = (data && data.products) || [];
        return products
          .filter((p) => p.published_at)
          .map((p) => {
            const variant = (p.variants && p.variants[0]) || {};
            return {
              title: p.title,
              url: `/products/${p.handle}`,
              image: p.images && p.images[0] ? p.images[0].src : "",
              price: variant.price || "",
              available: p.variants ? p.variants.some((v) => v.available) : true,
              searchWords: [
                ...normalize(p.title).split(/\s+/),
                ...normalize(p.product_type).split(/\s+/),
                ...normalize(p.vendor).split(/\s+/),
                ...(p.tags || []).flatMap((t) => normalize(t).split(/\s+/)),
              ].filter(Boolean),
            };
          });
      })
      .catch(() => []);
    return catalogPromise;
  }

  function scoreProduct(product, queryWords) {
    let total = 0;
    for (const qw of queryWords) {
      const s = fuzzyWordScore(qw, product.searchWords);
      if (s === 0) return 0;
      total += s;
    }
    return total;
  }

  async function getMatches(rawQuery) {
    const queryWords = normalize(rawQuery).split(/\s+/).filter(Boolean);
    if (queryWords.length === 0) return [];
    const catalog = await loadCatalog();
    return catalog
      .map((p) => ({ p, score: scoreProduct(p, queryWords) }))
      .filter((x) => x.score > 0)
      .sort((a, b) => b.score - a.score);
  }

  async function renderResults(query) {
    const q = query.trim();
    if (q.length === 0) {
      resultsEl.innerHTML = "";
      return;
    }

    const scored = await getMatches(q);

    if (scored.length === 0) {
      resultsEl.innerHTML = `<p class="search-overlay__empty">Keine Produkte gefunden für "${escapeHtml(query)}".</p>`;
      return;
    }

    resultsEl.innerHTML = scored
      .map(
        ({ p }) => `
        <a class="search-result" href="${p.url}">
          <img src="${p.image}" alt="${escapeHtml(p.title)}" class="search-result__img" />
          <span class="search-result__info">
            <span class="search-result__title">${escapeHtml(p.title)}</span>
            <span class="search-result__price">${p.price}${p.available === false ? " · Ausverkauft" : ""}</span>
          </span>
        </a>`
      )
      .join("");
  }

  openBtns.forEach((btn) => btn.addEventListener("click", openSearch));
  closeBtn && closeBtn.addEventListener("click", closeSearch);

  overlay.addEventListener("click", closeSearch);

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && drawer.classList.contains("is-open")) closeSearch();
  });

  input.addEventListener("input", (e) => {
    clearTimeout(debounceTimer);
    const value = e.target.value;
    debounceTimer = setTimeout(() => renderResults(value), 200);
  });

  if (form) {
    form.addEventListener("submit", async (e) => {
      e.preventDefault();
      const q = input.value.trim();
      if (!q) return;
      const matches = await getMatches(q);
      if (matches.length === 1) {
        window.location.href = matches[0].p.url;
      } else {
        window.location.href = `${searchUrl}?q=${encodeURIComponent(q)}&type=product`;
      }
    });
  }
});
